import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSelectModule } from 'ng-zorro-antd/select';

import { ChipModule } from '@libs/src/chip/chip.module';
import { DialogConfirmPromptModule } from '@libs/src/dialog-confirm-prompt/dialog-confirm-prompt.module';
import { TtcButtonSharedModule } from '@libs/src/ttc-button-shared/ttc-button-shared.module';
import { TtcChipListFormModule } from '@libs/src/ttc-chip-list-form/ttc-chip-list-form.module';
import { TtcMatDatepickerModule } from '@libs/src/ttc-mat-datepicker/ttc-mat-datepicker.module';
import { TtcMatInputModule } from '@libs/src/ttc-mat-input/ttc-mat-input.module';
import { TranslationLookupModule } from '@main-client/src/app/pipes/translation-lookup/translation-lookup.module';

import { GroupSetDevelopmentGoalComponent } from './group-set-development-goal.component';

@NgModule({
  declarations: [GroupSetDevelopmentGoalComponent],
  imports: [
    ChipModule,
    CommonModule,
    DialogConfirmPromptModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    MatSelectModule,
    NzCollapseModule,
    MatIconModule,
    NzInputModule,
    NzInputNumberModule,
    NzRadioModule,
    NzSelectModule,
    TtcButtonSharedModule,
    TtcChipListFormModule,
    TtcMatDatepickerModule,
    TtcMatInputModule,
    TranslationLookupModule,
  ],
  exports: [GroupSetDevelopmentGoalComponent],
})
export class GroupSetDevelopmentGoalModule {}
